import React from "react";
import classnames from "classnames";

import ResponsiveAccordion from "@/components/botanic/ResponsiveAccordion";

const FAQ = ({
  question,
  answer,
  initialShowPanel,
  onClick,
}: {
  answer: string;
  initialShowPanel?: boolean;
  onClick?: () => void;
  question: string;
}) => (
  <ResponsiveAccordion
    label={
      <h3
        data-testid="faq-question"
        className="font-bold heading--s normal-case"
      >
        {question}
      </h3>
    }
    open={initialShowPanel}
    onClick={onClick}
    className="border border-light-grey rounded px-lg pb-lg pt-xs bg-white mb-lg [&_.marker]:text-green"
    unfurlOnLarge={false}
  >
    <div
      className={classnames("dangerously-set-html -mt-sm")}
      dangerouslySetInnerHTML={{ __html: answer || "" }}
      data-testid="faq-answer"
    />
  </ResponsiveAccordion>
);

export default FAQ;
